import { useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import useRoutes from "./routes";
import RouteGuard from "./route.guard";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
export default function App() {
  const { pathname } = useLocation();
  const routes = useRoutes();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.items && route.items.length) {
        return getRoutes(route.items);
      }

      if (route.guard) {
        const { valid, redirect, state } = route.guard;
        return (
          <Route
            element={
              <RouteGuard valid={valid} redirect={redirect} state={state} />
            }
            key={route.key}
          >
            <Route exact path={route.route} element={route.component} />
          </Route>
        );
      }

      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }

      return null;
    });

  return (
    <>
      <Routes>{getRoutes(routes)}</Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}
